import { CloseButton } from '@cb/apricot-react';
import React from 'react';

import './Drawer.scss';

export type DrawerProps = {
  open?: boolean;
  title?: string;
  // eslint-disable-next-line
  onClose?: any;
  children: React.ReactElement;
  drawerId: string;
  // eslint-disable-next-line
  handleDrawerDirty?: any;
  // eslint-disable-next-line
  closeBtnRef: any;
};

export function Drawer(props: DrawerProps) {
  const { open = false, title = '', onClose, children, drawerId, handleDrawerDirty, closeBtnRef } = props;

  const drawerHeaderId = `drawer-header-${drawerId || ''}`;

  return (
    <div
      aria-label={`${title} Drawer`}
      className={`side-drawer ${open ? 'slide-open' : ''}`}
      role='dialog'
      id={drawerId}
      aria-hidden={!open}
      {...(!open ? { inert: true } : {})}
    >
      <div className='drawer-header cb-box-shadow-bottom' id={drawerHeaderId}>
        <CloseButton
          id={`${drawerId}-drawer-close-btn`}
          onClick={() => onClose()}
          aria-controls={drawerId}
          aria-label={'Close Drawer'}
          ref={closeBtnRef}
        />
        <div className='drawer-title'>{title}</div>
      </div>

      <div className='drawer-content'>
        {/* eslint-disable-next-line */}
        {React.Children.map(children, (child) => {
          if (!React.isValidElement(child) || typeof child.type === 'symbol') {
            return child;
          }
          return React.cloneElement(child, { onClose: onClose, handleDrawerDirty, closeBtnRef });
        })}
      </div>
    </div>
  );
}
